import React from 'react';

import {SubmitHandler, useForm} from 'react-hook-form';
import cn from 'classnames';
import {Link, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {t} from '@lingui/core/macro';
import {unwrapResult} from '@reduxjs/toolkit';

import {isPasswordResettingSelector, passwordResetRequest, IPasswordResetRequestForm} from 'entities/user';

import Button from 'shared/ui/Button/Button/Button';

import EmailInput from '../../../../../shared/ui/Input/InputEmail';
import {AppUrls} from '../../../../../shared/config/model/urls';

import {TypedDispatch} from '../../../../../shared/model/types';

import FormGroupWithError from '../../../../../shared/ui/FormGroup/FormGroupWithError';

import AuthWrapper from '../AuthWrapper';

import styles from '../Auth.module.scss';

const PasswordResetInit: React.FC = () => {
    const dispatch = useDispatch<TypedDispatch>();
    const navigate = useNavigate();

    const isLoading = useSelector(isPasswordResettingSelector);
    const {
        register,
        handleSubmit,
        getValues,
        formState,
        control,
    } = useForm<IPasswordResetRequestForm>({mode: 'onChange'});
    const {errors} = formState;

    const onSubmit: SubmitHandler<IPasswordResetRequestForm> = async(formData) => {
        try {
            const resultAction = await dispatch(passwordResetRequest(formData.email));
            const response = unwrapResult(resultAction);
            if (response.status) {
                navigate(`${AppUrls.PASSWORD_RESET_SENT}?email=${getValues('email')}`);
            }
        }catch (e){}
    };

    return (
        <AuthWrapper>
            <div className={styles.title_container}>
                <h2 className={cn(styles.title, styles.reset_title)}>
                    {t`Восстановление доступа`}
                </h2>
                <p>{t`Введите адрес email вашего аккаунта и мы пришлем на него ссылку для сброса пароля`}.</p>
            </div>

            <form onSubmit={handleSubmit(onSubmit)} className="reset-password-form">

                <FormGroupWithError
                    error={errors?.email?.message}
                >
                    <EmailInput
                        register={register}
                        required
                        control={control}
                        placeholderToLabel
                    />
                </FormGroupWithError>

                <div className="form-group">
                    <Button
                        type="submit"
                        loading={isLoading}
                        block
                    >
                        {t`Сбросить пароль`}
                    </Button>
                </div>
            </form>

            <p className={cn(styles.new_account_wrapper, 'text-muted')}>
                {t`Вспомнили ?`} <Link to={AppUrls.LOGIN} className={styles.register_link}>{t`Войти`}!</Link>
            </p>
        </AuthWrapper>
    );
};

export default PasswordResetInit;